<template>
  <div class="versionManage">
    <div>
      <lh-button v-if="maxVersion" @click="visible=true">添加新版本</lh-button>
      <lh-dialog :visible.sync="visible">
        <div slot="title">添加版本</div>
        <table>
          <tr>
            <td>上传安装包</td>
            <td>
              <lh-button accept=".apk" @change="selectFile">
                选择apk文件
              </lh-button>
              <div v-if="apkFile" style="font-size: 10px;color: red;">
                {{ apkFile.name }}
              </div>
            </td>
          </tr>
          <tr v-if="addForceVersionApi">
            <td>是否强制更新</td>
            <td>
              <lh-radio v-model="force" :radioValue="true">是</lh-radio>
              <lh-radio v-model="force" :radioValue="false">否</lh-radio>
            </td>
          </tr>
          <tr>
            <td>
              设置版本号
              <div v-if="maxVersion" style="font-size: 10px;color: red;">
                *当前最大版本：{{maxVersion}}
              </div>
            </td>
            <td>
              <lh-select v-model="selectV">
                <lh-option v-for="(item,index) of selectVList" :value="item" :key="index">
                  {{ item }}
                </lh-option>
              </lh-select>
            </td>
          </tr>
        </table>
        <div slot="footer">
          <lh-button @click="confirm">确认</lh-button>
        </div>
      </lh-dialog>
    </div>
    <lh-table>
      <lh-tr>
        <lh-th>序号</lh-th>
        <lh-th>版本号</lh-th>
        <lh-th>类型</lh-th>
        <lh-th width="250px">地址</lh-th>
        <lh-th>更新时间</lh-th>
        <lh-th>操作</lh-th>
      </lh-tr>
      <lh-tr v-for="(item,index) of versionList" :key="item.id">
        <lh-td>{{ index+1 }}</lh-td>
        <lh-td>{{ item.notes }}</lh-td>
        <lh-td>{{ item.resourcesType.type }}</lh-td>
        <lh-td>{{ item.url }}</lh-td>
        <lh-td>{{ item.updateTime }}</lh-td>
        <lh-td>
          <lh-button @click="setLastVersion(index)" :disabled="index==0">
            {{ index==0?'最新版本':"设置为最新版本" }}
          </lh-button>
          <lh-button @click="deleteVersion(index)" icon="lh-icon-delete" backgroundColor="red">
            删除此版本
          </lh-button>
        </lh-td>
      </lh-tr>
    </lh-table>
    <lh-empty v-if="versionList.length==0"></lh-empty>
  </div>
</template>

<script>
import axios from "../../../utils/request"
// import { uploadFile } from '../../../utils/file'
export default {
  name:"VersionManage",
  props:{
    addNotForceVersionApi:{
      type:String,
      default:null
    },
    addForceVersionApi:{
      type:String,
      default:null
    },
    setLastVersionApi:{
      type:String,
      default:null
    },
    deleteVersionApi:{
      type:String,
      default:null
    },
    getVersionListApi:{
      type:String,
      default:null
    },
    getMaxVersionApi:{
      type:String,
      default:null
    }
  },
  data:function(){
    return{
      visible:false,
      versionList:[],
      maxVersion:"0.0.0",
      apkFile:null,
      selectV:"1.0.0",
      force:false
    }
  },
  mounted:function(){
    this.init();
  },
  methods:{
    init:function(){
      this.getVersionList();
      this.getMaxVersion();
    },
    selectFile:function(e){
      this.apkFile=e.target.files[0];
    },
    setLastVersion:function(index){
      this.$lhMessageBox("设置最新版本","确认设置"+this.versionList[index].notes+"为最新版本").then(()=>{
        this.$lhLoading.open("请求中...");
        axios.post(this.setLastVersionApi,{id:this.versionList[index].id}).then(()=>{
          this.$lhMessage("success","设置成功");
          this.init();
        }).catch((err)=>{
          this.$lhMessage("error",err.message);
        }).finally(()=>{
          this.$lhLoading.close();
        })
      })
    },
    deleteVersion:function(index){
      this.$lhMessageBox("删除版本","确认删除"+this.versionList[index].notes+"版本").then(()=>{
        this.$lhLoading.open("删除中...");
        let form=new FormData();
        form.append("id",this.versionList[index].id);
        axios.post(this.deleteVersionApi,form).then(()=>{
          this.$lhMessage("success","删除成功");
          this.init();
        }).catch((err)=>{
          this.$lhMessage("error",err.message);
        }).finally(()=>{
          this.$lhLoading.close();
        })
      })
    },
    getVersionList:function(){
      this.$lhLoading.open("加载中...");
      axios.get(this.getVersionListApi).then((data)=>{
        this.versionList=data;
      }).catch((err)=>{
        this.$lhMessage(err.message);
      }).finally(()=>{
        this.$lhLoading.close();
      });
    },
    getMaxVersion:function(){
      this.$lhLoading.open("加载中...");
      axios.get(this.getMaxVersionApi).then((data)=>{
        if(data!=null){
          this.maxVersion=data;
        }
      }).catch((err)=>{
        this.$lhMessage(err.message);
      }).finally(()=>{
        this.$lhLoading.close();
      });
    },
    confirm:function(){
      if(this.apkFile==null){
        this.$lhMessage("warn","请上传安装包");
        return;
      }
      let url=this.addNotForceVersionApi;
      if(this.force){
        url=this.addForceVersionApi;
      }
      this.$lhLoading.open("上传中...");

      let formData=new FormData();
      formData.append("file",this.apkFile);
      formData.append("version",this.selectV);
      axios.post(url,formData).then(()=>{
        this.$lhMessage("success","上传成功");
        this.visible=false;
        this.init();
      }).finally(()=>{
        this.$lhLoading.close();
      })

      // uploadFile(url,this.apkFile,{version:this.selectV}).then(()=>{
      //   this.$lhMessage("success","上传成功");
      //   this.visible=false;
      //   this.init();
      // }).finally(()=>{
      //   this.$lhLoading.close();
      // })
    }
  },
  computed:{
    selectVList:function(){
      let vList=this.maxVersion.split(".");
      let selectList=[];
      let v1=(parseInt(vList[0])+1)+".0.0";
      let v2=vList[0]+"."+(parseInt(vList[1])+1)+".0";
      let v3=vList[0]+"."+vList[1]+"."+(parseInt(vList[2])+1);
      selectList.push(v1);
      selectList.push(v2);
      selectList.push(v3);
      return selectList;
    }
  },
  watch:{
    selectVList:{
      immediate:true,
      handler:function(newVal){
        if(newVal.length>0){
          this.selectV=newVal[0];
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.versionManage{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>